<template>
<div class="chapter">
<div class="inner_page">
<p><a id="epi"></a></p>
<div class="epiv"><i>Both Miss Eckhart and Virgie Rainey were human beings terribly at large, roaming on the face of the earth. And there were others of them—human beings, roaming, like lost beasts.</i></div>
<div class="eps">—EUDORA WELTY, “June Recital”</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tama_9781571318879_oeb_epi_r1.vue?93f42780